import {Link} from "react-router-dom";
import {toInternalPath} from "../utils/dibUrls";
import {useExperimentalMode} from "../features/chat/useExperimentalMode";

type ExperimentalLinkProps = {
    href: string;
    className?: string;
    children: React.ReactNode;
    transition?: boolean;
};

export const ExperimentalLink = ({
    href,
    className,
    children,
    transition = true,
}: ExperimentalLinkProps) => {
    const {isExperimental} = useExperimentalMode();
    const internalPath = isExperimental ? toInternalPath(href) : null;

    return internalPath ? (
        <Link
            to={internalPath}
            viewTransition={transition}
            className={className}
        >
            {children}
        </Link>
    ) : (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
        >
            {children}
        </a>
    );
};
